import { IClone } from "src/@types/clones";

export const getEditCloneInitialValues = (clone: IClone) => ({
  ...clone,
  company_presentation: [],
  logo: undefined,
  main_photo: undefined,
  industry: clone.industry.slug,
  information_sold: clone.information_sold.map(({ slug }) => slug),
  clone_type: clone.clone_type.slug,
  prohibited_countries: clone.prohibited_countries.map(({ slug }) => slug),
});
